import React from 'react';
import Main from '../components/Main';
import map from '../assets/images/map.png';
import '../assets/styles/Contact.css';

// Contact Page

const Contact = () => {
  return (
    <Main componentList={[

      <div>
        <h6 className="mb-3 top_sentence">
          IQOSYS office and contact details
        </h6>

        <h6 class="fw-bold mb-3" style={{color : "#203864"}}>
          Paris office
        </h6>
        
        <h6 class="mb-3" style={{color : "#203864"}}>
          Address : 123 Avenue Champs-Élysées, Paris <br/>
          Telephone number : +33 1 23 45 67 89 <br/>
          Map
        </h6>

        <div class="map-container mt-3">
          <img src={map} alt="Paris office map" />
        </div>

        <br></br>

        <h6 class="text-primary fw-bold mb-3"  className='top_sentence' style={{paddingTop:"5px"}}>
          London office
        </h6>

        <h6 class="text-primary fw-bold mb-3"  className='top_sentence'style={{paddingTop:"5px"}}>
          New York office
        </h6>

        <h6 class="text-primary fw-bold mb-3"  className='top_sentence'style={{paddingTop:"5px"}}>
          Brussels office
        </h6>
      </div>
      ]} />
  );
};

export default Contact;